import { createSelector } from '@reduxjs/toolkit';
import { selectTechnologiesResult } from '@services/df/technologies/manual';
import { TechnologyMaterial, RootState } from '@types';
import { CUTTER } from '@constants';

export const selectTechnologies = createSelector(selectTechnologiesResult, response => {
    return response.data?.results;
});

export const selectIsLoadingTechnologies = createSelector(selectTechnologiesResult, response => {
    return response.isLoading;
});

/**
 * @deprecated use `selectTechnologies` and `selectIsLoadingTechnologies` instead
 */
export const selectTechnologiesOldEndpoint = (state: RootState) => state.technologies.results;
export const selectIsLoadingTechnologiesOldEndpoint = (state: RootState) => state.technologies.isLoading;

export const selectMaterialById = (state: RootState, materialId: number) => {
    const technologies = selectTechnologiesOldEndpoint(state);

    let material: TechnologyMaterial | undefined = undefined;

    if (!materialId) return material;

    for (const technology of technologies) {
        material = technology.materials.find(material => {
            return material.id === materialId;
        });

        if (material) {
            return material;
        }
    }

    return material;
};

export const selectMaterialBelongsCncCutter = (state: RootState, materialId: number) => {
    const technologies = selectTechnologiesOldEndpoint(state);
    const technology = technologies.find(technology => technology.id === CUTTER);

    if (!technology?.materials?.length) {
        return false;
    }

    return technology.materials.some(material => material.id === materialId);
};
